import React, { useEffect } from 'react';
import { DatePicker, Form, Input, Modal } from 'antd';
import dayjs, { type Dayjs } from 'dayjs';

export interface SnoozeFollowupFormValues {
  newDueDate: Dayjs;
  reason: string;
}

interface SnoozeFollowupModalProps {
  open: boolean;
  taskId: string | null;
  loading?: boolean;
  onCancel: () => void;
  onSubmit: (taskId: string, newDueDate: string, reason: string) => void;
}

const SnoozeFollowupModal: React.FC<SnoozeFollowupModalProps> = ({
  open,
  taskId,
  loading,
  onCancel,
  onSubmit,
}) => {
  const [form] = Form.useForm<SnoozeFollowupFormValues>();

  useEffect(() => {
    if (open) {
      form.setFieldsValue({ newDueDate: dayjs().add(1, 'day') });
    } else {
      form.resetFields();
    }
  }, [open, form]);

  const handleOk = () => {
    if (!taskId) return;
    form.validateFields().then((values) => {
      onSubmit(
        taskId,
        values.newDueDate.format('YYYY-MM-DD'),
        values.reason.trim()
      );
    });
  };

  return (
    <Modal
      title="Snooze follow-up"
      open={open}
      onOk={handleOk}
      onCancel={onCancel}
      confirmLoading={loading}
      destroyOnClose
    >
      <div className="cp-form-section">
        <Form form={form} layout="vertical">
          <Form.Item
            name="newDueDate"
            label="New due date"
            rules={[{ required: true, message: 'Due date is required' }]}
          >
            <DatePicker
              style={{ width: '100%' }}
              disabledDate={(current) => current != null && current < dayjs().startOf('day')}
              getPopupContainer={(trigger) => trigger.parentElement!}
            />
          </Form.Item>
          <Form.Item
            name="reason"
            label="Reason"
            rules={[{ required: true, message: 'Reason is required' }]}
          >
            <Input.TextArea rows={3} placeholder="Why is this being deferred?" maxLength={4000} />
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default SnoozeFollowupModal;
